import React, { ChangeEventHandler, } from 'react';
import './TextArea.scss';
import { useTheme } from '../../../ThemeContext';

interface TextAreaProps {
    id?: string;
    mixin?: string;
    label: string;
    name: string;
    value: string;
    placeholder: string;
    onChange: ChangeEventHandler<HTMLTextAreaElement>;
    onBlur: ChangeEventHandler<HTMLTextAreaElement>;
    readOnly?: boolean;
}

const TextArea: React.FC<TextAreaProps> = ({ id, name, label, onChange, value, onBlur, placeholder, readOnly, ...rest }) => {
    return (
        <div className='form_control' {...rest}>
            <label className='label'>{label}</label>
            <textarea
                id={id}
                name={name}
                placeholder={placeholder}
                className="textarea "
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                readOnly={readOnly}
            />
        </div>
    );
};

export default TextArea;